import styled from "@emotion/styled";

export const SpinnerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 20px;
  z-index: 100;
`